import React, { useState } from 'react';
import styled from 'styled-components';
import { Tab, TabPanel } from './index';
import { TabList } from './shared/Tab';
import { generateTabContent } from './shared/TabPanel';
const StyledTabList = styled(TabList) `
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0px;
  padding: 0 15px;
  background-color: transparent;
`;
const ListContainer = styled.li `
  list-style: none;
  margin-bottom: 1px;
  width: 100%;
`;
const TransitionContainer = styled.div `
  overflow: hidden;
  max-height: ${({ isOpen }) => (isOpen ? '9999px' : 0)};
`;
// TODO: ADD TESTS
export const NarrowTabs = ({ items }) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const TabsJSX = items.map((item, index) => {
        if (index > 3) {
            return null;
        }
        else {
            const isTabSelected = selectedIndex === index;
            const tabLabel = item && item.fields && item.fields.tabLabel;
            const content = generateTabContent(item);
            return (React.createElement(ListContainer, { key: index },
                React.createElement(Tab, { isSelected: isTabSelected, field: tabLabel, index: index, itemId: item.id, onClick: () => setSelectedIndex(index) }),
                React.createElement(TransitionContainer, { isOpen: isTabSelected },
                    React.createElement(TabPanel, { selectedIndex: selectedIndex, itemId: item.id }, isTabSelected ? content : null))));
        }
    });
    return React.createElement(StyledTabList, null, TabsJSX);
};
